import React from "react";

const Button = ({
  variant,
  children,
  onClick,
  compact,
  loading,
  icon,
  iconLeft,
  iconAlt,
  iconFilter,
  width,
  customClass,
  disabled,
}) => {
  const classes = [
    "button",
    variant && `button--${variant}`,
    compact && "button--compact",
    width,
    customClass,
  ]
    .filter(Boolean)
    .join(" ");

  const getIcon = (icon, alt) => {
    return (
      <img
        src={icon}
        alt={alt}
        style={{
          filter: iconFilter || getIconColor(),
          marginLeft: children && !iconLeft ? "8px" : "none",
          marginRight: children && iconLeft ? "8px" : "none",
        }}
      />
    );
  };
  const getIconColor = () => {
    switch (variant) {
      case "primary":
        return "brightness(0) invert(1)";
      default:
        return "none";
    }
  };

  return (
    <button
      className={classes}
      onClick={!loading ? onClick : undefined}
      disabled={loading || disabled}
      style={{ width: width ? width : "auto" }}
    >
      {loading && <div className="spinner-variant"></div>}
      {!loading && (
        <>
          {iconLeft && getIcon(icon, iconAlt)}
          {children}
          {icon && !iconLeft && getIcon(icon, iconAlt)}
        </>
      )}
    </button>
  );
};

export default Button;
